import {useState} from 'react';
import {Grid, Alert, Button, TextField, Typography} from "@mui/material";
import {useActionData, Form, NavLink} from 'react-router-dom';
import api from "../../hooks/useApi";
import PageTitle from "../../components/PageTitle";
import PasswordField from '../../components/PasswordField';

export async function action({ request, params }) {
    //console.log(request);
    const formData = await request.formData();
    const payload = Object.fromEntries(formData.entries());
    if (payload.password !== payload.password_confirm) {
        return {status: 400, newUser: {password_confirm: 'Паролі не збігаються'}};
    }
    let status, ret_val = {};
    try {
        const response = await api.post('/api/users/partners/', payload);
        if (response.status === 201) {
            status = 'success';
            ret_val = response.data;
        } else {
            status = 'unexpected';
        }
    } catch (e) {
        status = e.response?.status || 500;
        if (e.response) {
            //console.log(e.response.status);  // Логируем статус ошибки
            //console.log(e.response.data);    // Логируем данные ошибки, включая form.errors
        } else {
            //console.log(e.message);          // Логируем общую ошибку
        }
        ret_val = e.response ? e.response.data : {};
    }
    return { status: status, newUser: ret_val };
}

export async function loader({ request, params }) {
    return null;
}



export default function NewUser() {
    const action_result = useActionData();
    const isSuccess = action_result?.status === 'success';
    const errors = !isSuccess ? (action_result?.newUser || {}) : {};
    const [passwords, setPasswords] = useState({password: '', password_confirm: ''});
    const setGeneratedPassword = (value) => setPasswords({password: value, password_confirm: value});
    return (
        <Grid container spacing={2} component={Form} method="post" sx={{p:2}}>
            <Grid item xs={12}><PageTitle title="Новий партнер"/><Typography>Роль «Партнер» буде призначена сервером.</Typography></Grid>
            {isSuccess ? <Grid item xs={12}><Alert severity="success">Партнера створено. <NavLink to="/all-users">Перейти до користувачів</NavLink></Alert></Grid> : <>
                {action_result && <Grid item xs={12}><Alert severity="error">Не вдалося створити партнера</Alert></Grid>}
                <Grid item xs={12} md={6}><TextField required fullWidth name="email" label="Email" type="email" /></Grid>
                <Grid item xs={12} md={6}><TextField required fullWidth name="name" label="Ім’я" /></Grid>
                <Grid item xs={12} md={6}><TextField required fullWidth name="last_name" label="Прізвище" /></Grid>
                <Grid item xs={12} md={6}><TextField required fullWidth name="second_name" label="По батькові" /></Grid>
                <Grid item xs={12} md={6}><TextField fullWidth name="phone" label="Телефон" /></Grid>
                <Grid item xs={12} md={6}>
                    <PasswordField
                        required
                        name="password"
                        label="Пароль"
                        value={passwords.password}
                        onChange={(value) => setPasswords((current) => ({...current, password: value}))}
                        onGenerate={setGeneratedPassword}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <PasswordField
                        required
                        name="password_confirm"
                        label="Підтвердження пароля"
                        value={passwords.password_confirm}
                        onChange={(value) => setPasswords((current) => ({...current, password_confirm: value}))}
                        onGenerate={setGeneratedPassword}
                    />
                </Grid>
                <Grid item xs={12}><Button type="submit" variant="contained">Створити партнера</Button></Grid>
                {Object.entries(errors).map(([field, value]) => <Grid item xs={12} key={field}><Alert severity="error">{field}: {Array.isArray(value) ? value.join(', ') : String(value)}</Alert></Grid>)}
            </>}
        </Grid>
    );
}
